import React, { useState } from 'react';


import { styled, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import axios from 'axios';

function Inputfields() {
    
  const [keyWord,setKeyWordi] =useState();
 
  const searchKey = async(e)=>{
    e.preventDefault();
    await axios.post('http://localhost:8800/getdata/keyword',{
      keyword: keyWord
    })
  }


    const Container = styled(Typography)`
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 2rem;
    color: #ffff;
    border: 2px solid #fff;
    padding: 8px;
    font-weight: 600
  `

 


  return (
    <div style={{display:"flex", justifyConyent:"center",alignItems: "center",flexDirection:"column",backgroundColor:"lightslategray",height:"100vh"}}>
       
         <Container>Enter Your KeyWord For Scrapp Data</Container>
         <input className="form-control" style={{"width": "300px", "marginLeft": "20",}} onChange={(e)=>setKeyWordi(e.target.value)} type="text" placeholder="Default input" value={keyWord}  aria-label="default input example"></input>
    
        <Button variant="contained" style={{marginTop: "30px"}} onClick={(e)=>searchKey(e)}>Contained</Button>
       
      
    </div>
  )
}

export default Inputfields